import Vue from 'vue'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import i18n from '@/i18n'

i18n.mergeLocaleMessage('de', {
  yes: 'Ja',
  no: 'Nein',
  save: 'Speichern',
  cancel: 'Abbrechen'
})

i18n.mergeLocaleMessage('en', {
  yes: 'Yes',
  no: 'No',
  save: 'Save',
  cancel: 'Cancel'
})

const options = {
  toast: {
    position: SnotifyPosition.centerCenter
  }
}

class Confirm {
  constructor (title, body, confirmCB, cancelCB = () => {}) {
    this.title = title
    this.body = body
    this.confirmCB = confirmCB
    this.cancelCB = cancelCB
  }

  open () {
    Vue.prototype.$snotify.confirm(this.body, this.title, {
      buttons: [
        {
          text: i18n.t('yes'),
          action: (toast) => {
            this.confirmCB()
            Vue.prototype.$snotify.remove(toast.id)
          },
          bold: true
        },
        {
          text: i18n.t('no'),
          action: (toast) => {
            this.cancelCB()
            Vue.prototype.$snotify.remove(toast.id)
          }
        }
      ]
    })
  }
}

class Prompt {
  constructor (title, body, confirmCB, value = undefined, cancelCB = () => {}) {
    this.title = title
    this.body = body
    this.confirmCB = confirmCB
    this.cancelCB = cancelCB
    this.value = value
  }

  open () {
    Vue.prototype.$snotify.prompt(this.body, this.title, {
      buttons: [
        {
          text: i18n.t('save'),
          action: (toast) => {
            this.confirmCB(toast.value || this.value || '')
            Vue.prototype.$snotify.remove(toast.id)
          },
          bold: true
        },
        {
          text: i18n.t('cancel'),
          action: (toast) => {
            this.cancelCB()
            Vue.prototype.$snotify.remove(toast.id)
          }
        }
      ],
      placeholder: this.value || '',
      initialValue: this.value
    })
  }
}

class Success {
  constructor (body, timeout) {
    this.body = body
    this.timeout = timeout
  }

  open () {
    Vue.prototype.$snotify.success(this.body, {
      timeout: this.timeout,
      position: 'rightBottom',
      showProgressBar: false
    })
  }
}

class Info {
  constructor (body) {
    this.body = body
  }

  open () {
    Vue.prototype.$snotify.info(this.body, {
      timeout: 700,
      showProgressBar: false,
      position: 'rightBottom'
    })
  }
}

class Warning {
  constructor (body) {
    this.body = body
  }

  open () {
    Vue.prototype.$snotify.warning(this.body, {
      timeout: 1500,
      showProgressBar: false,
      position: 'rightBottom'
    })
  }
}

class Error {
  constructor (body) {
    this.body = body
  }

  open () {
    Vue.prototype.$snotify.error(this.body, {
      timeout: false,
      showProgressBar: false,
      position: 'rightBottom'
    })
  }
}

class Async {
  constructor (body, successBody, errorBody) {
    this.body = body
    if (successBody || errorBody) {
      this.autoClose = false
      this.successBody = successBody
      this.errorBody = errorBody
    } else {
      this.autoClose = true
    }
  }

  open (action) {
    const uniqueId = new Date().getUTCMilliseconds() + Math.random()
    Vue.prototype.$snotify.async(this.body, () => new Promise((resolve, reject) => {
      action.then(
        () => {
          if (this.autoClose) {
            Vue.prototype.$snotify.remove(uniqueId, true)
          } else {
            resolve({
              body: this.successBody,
              config: {
                timeout: 700,
                closeOnClick: true
              }
            })
          }
        },
        () => {
          if (this.autoClose) {
            Vue.prototype.$snotify.remove(uniqueId, true)
          } else {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({
              body: this.errorBody,
              config: {
                closeOnClick: true
              }
            })
          }
        }
      )
    }), {
      id: uniqueId,
      position: 'rightBottom'
    })
  }
}

export default {
  install (Vue) {
    Vue.use(Snotify, options)
  }
}

export { Confirm, Prompt, Success, Info, Error, Async, Warning }
